import axios from "axios";

// 接口请求域名配置
// const baseUrl = "http://192.168.1.95:8080"; // 本地测试接口前缀
const baseUrl = "https://zd.zdagriiot.com/prod-api"; // 生产环境接口前缀

const service = axios.create({
  baseURL: baseUrl,
  timeout: 10000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    return res;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
